import { API_URL } from "./api";

export interface PromotePayload {
  task_id: string;
  fields: Record<string, string>;
}

export interface PromoteResponse {
  status: string;
  source?: string;
  saved_as?: string;
  assigned?: Record<string, number | null>;
  total_blocks?: number;
}

export const promoteTrainingSample = async (payload: PromotePayload): Promise<PromoteResponse> => {
  const resp = await fetch(`${API_URL}/training/promote`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(`HTTP ${resp.status}: ${text}`);
  }
  return resp.json() as Promise<PromoteResponse>;
};
